/* globals console, document, module, require, setTimeout */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
'use strict';

const jQuery = require('jquery'),
    Clipboard = require('clipboard'),
    _ = require('lodash'),
    Marionette = require('backbone.marionette'),
    formProcessor = require('../utilities/formProcessor').processor, // @acavan! - need use specific processors
    helpers = require('../utilities/handlebars').helpers,
    templates = require('../utilities/handlebars').templates,
    EOL = null;

module.exports = Marionette.View.extend({
    attributes: {
        class: 'share-dialog modal-dialog modal-rts',
        role: 'document'
    },
    events: {
        'click button': 'onClickButton'
    },
    tagName: 'div',
    template: templates.shareDialog,
    //
    close: function () {
        jQuery('#screenReaderAnnouncementsAssertive').text('Dialog closed');
        jQuery(document).off('keyup', _.bind(this.onKeyup, this));
        this.modal.empty();
        this.modal.modal('hide');
        this.modal.modal('dispose');
        if (this.options.modalModal) {
            jQuery('#modal').modal('show');
            jQuery('#modal').modal('handleUpdate');
        }
        if (this.options.focus) {
            _.defer(_.bind(function () {
                console.log(this.options.focus, jQuery('[data-focus=' + this.options.focus + ']').length);
                jQuery('[data-focus=' + this.options.focus + ']').focus();
                // jQuery('[data-action=email]').focus();
            }, this));
        }
        this.destroy();
    },
    initialize: function () {
        this.scrollTop = jQuery(document).scrollTop();
        // console.log('modalDialog.initialize - scrollTop:%s', this.scrollTop);
        this.modal = jQuery(this.options.modalModal ? '#modalModal' : '#modal');
        this.templateContext = {
            label: this.options.label,
            body: this.options.body,
            copy: this.options.url,
            href: this.options.url,
            modalModal: this.options.modalModal ? true : false
        };
        this.templateContext[this.options.mode] = true;
        this.render();
    },
    onClickButton: function (event) {
        const action = event.currentTarget.dataset.action;
        let bubble = false,
            knownAction = false,
            serializedArray;
        switch (action) {
            case 'copy':
                bubble = true;
                break;
            // case 'email':
            //     // jQuery('<a target="_top" href="' + this.options.href + '"></a>')[0].click();
            //     window.top.location = this.options.href;
            //     break;
            case 'cancel':
                knownAction = true; // jshint ignore:line
                // intentionally fall through...
            default:
                if (!knownAction) {
                    console.log('create.onClickButton - action:%s', action);
                }
                this.close();
                this.trigger('modalDialog:' + action);
                break;
        }
        return bubble;
    },
    onKeyup: function (event) {
        let selector,
            element;
        switch (event.which) {
            case 27: // escape
                // console.log('modalDialog.keyup - escape');
                selector = '[data-action=cancel]';
                break;
            default:
                break;
        }
        if (selector) {
            element = this.$el.find(selector);
            if (!element.attr('disabled')) {
                element.trigger('click');
            }
        }
    },
    onRender: function () {
        if (this.options.modalModal) {
            jQuery('#modal').modal('hide');
        }
        this.$el.append('<div class="iframe-marker" data-iframe-height="1"></div>');
        this.modal.html(this.$el);
        this.modal.modal({backdrop: 'static', focus: true, keyboard: false});
        jQuery(document).on('keyup', _.bind(this.onKeyup, this));
        this.clipboard = new Clipboard('#clipboardButton');
        this.clipboard.on('success', _.bind(function (element) {
            element.clearSelection();
            this.$el.find('button[data-action=cancel').text(helpers.l10n('buttonClose'));
        }, this));
        this.$el.find('[data-toggle=popover]')
            .popover()
            .on('shown.bs.popover', function (event) {
                setTimeout(_.bind(function () {
                    jQuery(this).popover('hide');
                }, this), 2000);
            });
        return this;
    }
});

